// ============================================================================
// ARABIC BIBLE PASSAGES - فان دايك
// ============================================================================
// نصوص الكتاب المقدس بالعربية مع أرقام سترونج

export const biblePassagesAr = {
  "Takween_1": {
    book: "التكوين",
    chapter: 1,
    title: "خلق العالم",
    verses: [
      { number: 1, text: "فِي الْبَدْءِ خَلَقَ اللهُ السَّمَاوَاتِ وَالأَرْضَ", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "وَكَانَتِ الأَرْضُ خَرِبَةً وَخَالِيَةً، وَعَلَى وَجْهِ الْغَمْرِ ظُلْمَةٌ، وَرُوحُ اللهِ يَرِفُّ عَلَى وَجْهِ الْمِيَاهِ", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "وَقَالَ اللهُ: لِيَكُنْ نُورٌ، فَكَانَ نُورٌ", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "وَرَأَى اللهُ النُّورَ أَنَّهُ حَسَنٌ. وَفَصَلَ اللهُ بَيْنَ النُّورِ وَالظُّلْمَةِ", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "وَدَعَا اللهُ النُّورَ نَهَارًا، وَالظُّلْمَةُ دَعَاهَا لَيْلاً. وَكَانَ مَسَاءٌ وَكَانَ صَبَاحٌ يَوْمًا وَاحِدًا", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "وَقَالَ اللهُ: لِيَكُنْ جَلَدٌ فِي وَسَطِ الْمِيَاهِ. وَلْيَكُنْ فَاصِلاً بَيْنَ مِيَاهٍ وَمِيَاهٍ", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "فَعَمِلَ اللهُ الْجَلَدَ، وَفَصَلَ بَيْنَ الْمِيَاهِ الَّتِي تَحْتَ الْجَلَدِ وَالْمِيَاهِ الَّتِي فَوْقَ الْجَلَدِ. وَكَانَ كَذلِكَ", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "وَدَعَا اللهُ الْجَلَدَ سَمَاءً. وَكَانَ مَسَاءٌ وَكَانَ صَبَاحٌ يَوْمًا ثَانِيًا", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "فَخَلَقَ اللهُ الإِنْسَانَ عَلَى صُورَتِهِ. عَلَى صُورَةِ اللهِ خَلَقَهُ. ذَكَرًا وَأُنْثَى خَلَقَهُمْ", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "وَرَأَى اللهُ كُلَّ مَا عَمِلَهُ فَإِذَا هُوَ حَسَنٌ جِدًّا. وَكَانَ مَسَاءٌ وَكَانَ صَبَاحٌ يَوْمًا سَادِسًا", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Mazameer_23": {
    book: "المزامير",
    chapter: 23,
    title: "الرب راعيّ",
    verses: [
      { number: 1, text: "الرَّبُّ رَاعِيَّ فَلاَ يُعْوِزُنِي شَيْءٌ", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "فِي مَرَاعٍ خُضْرٍ يُرْبِضُنِي. إِلَى مِيَاهِ الرَّاحَةِ يُورِدُنِي", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "يَرُدُّ نَفْسِي. يَهْدِينِي إِلَى سُبُلِ الْبِرِّ مِنْ أَجْلِ اسْمِهِ", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "أَيْضًا إِذَا سِرْتُ فِي وَادِي ظِلِّ الْمَوْتِ لاَ أَخَافُ شَرًّا، لأَنَّكَ أَنْتَ مَعِي. عَصَاكَ وَعُكَّازُكَ هُمَا يُعَزِّيَانِنِي", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "تُرَتِّبُ قُدَّامِي مَائِدَةً تُجَاهَ مُضَايِقِيَّ. مَسَحْتَ بِالدُّهْنِ رَأْسِي. كَأْسِي رَيَّا", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "إِنَّمَا خَيْرٌ وَرَحْمَةٌ يَتْبَعَانِنِي كُلَّ أَيَّامِ حَيَاتِي، وَأَسْكُنُ فِي بَيْتِ الرَّبِّ إِلَى مَدَى الأَيَّامِ", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Yohanna_3": {
    book: "يوحنا",
    chapter: 3,
    title: "يسوع ونيقوديموس",
    verses: [
      { number: 16, text: "لأَنَّهُ هكَذَا أَحَبَّ اللهُ الْعَالَمَ حَتَّى بَذَلَ ابْنَهُ الْوَحِيدَ، لِكَيْ لاَ يَهْلِكَ كُلُّ مَنْ يُؤْمِنُ بِهِ، بَلْ تَكُونُ لَهُ الْحَيَاةُ الأَبَدِيَّةُ", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "لأَنَّهُ لَمْ يُرْسِلِ اللهُ ابْنَهُ إِلَى الْعَالَمِ لِيَدِينَ الْعَالَمَ، بَلْ لِيَخْلُصَ بِهِ الْعَالَمُ", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "اَلَّذِي يُؤْمِنُ بِهِ لاَ يُدَانُ، وَالَّذِي لاَ يُؤْمِنُ قَدْ دِينَ، لأَنَّهُ لَمْ يُؤْمِنْ بِاسْمِ ابْنِ اللهِ الْوَحِيدِ", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Feelibi_4": {
    book: "فيلبي",
    chapter: 4,
    title: "سلام الله",
    verses: [
      { number: 4, text: "اِفْرَحُوا فِي الرَّبِّ كُلَّ حِينٍ، وَأَقُولُ أَيْضًا: افْرَحُوا", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "لاَ تَهْتَمُّوا بِشَيْءٍ، بَلْ فِي كُلِّ شَيْءٍ بِالصَّلاَةِ وَالدُّعَاءِ مَعَ الشُّكْرِ، لِتُعْلَمْ طِلْبَاتُكُمْ لَدَى اللهِ", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "وَسَلاَمُ اللهِ الَّذِي يَفُوقُ كُلَّ عَقْل، يَحْفَظُ قُلُوبَكُمْ وَأَفْكَارَكُمْ فِي الْمَسِيحِ يَسُوعَ", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "أَسْتَطِيعُ كُلَّ شَيْءٍ فِي الْمَسِيحِ الَّذِي يُقَوِّينِي", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesAr;
